import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import {
  ExportReportsRequestBody,
  SharepointExportResponse,
} from '../entities/sharepoint-export-entities';

const BASE_URL = `${environment.constructionDocumentsApiUrl}/construction-reports`;

@Injectable({
  providedIn: 'root',
})
export class SharepointExportApiService {
  private readonly http = inject(HttpClient);

  getConstructionReports$(ifsNumber: string) {
    return this.http.get<SharepointExportResponse>(`${BASE_URL}/${ifsNumber}`);
  }

  exportReports$ = (ifsNumber: string, requestBody: ExportReportsRequestBody) =>
    this.http.post(`${BASE_URL}/export/${ifsNumber}`, requestBody);

  refreshHcConstructionReports$(ifsNumber: string) {
    return this.http.get<void>(`${BASE_URL}/refresh/${ifsNumber}`);
  }
}
